import React from "react"
import {
	Flex,
	HeaderLogo,
	INNER_MAX_WIDTH,
	colors,
	fontWeight,
} from "@capioweb/ui-components/src"
import { DesktopPrimaryMenu } from "./DesktopPrimaryMenu"
import { PrimaryMenuProps } from "../types"
import { HeaderContext } from "../context/HeaderContext"
import { LocalesContext, UIContext } from "../../../context"
import { headerLogoSvg } from "@capioweb/ui-components/src/components/HeaderLogo/assets"
import { assetBaseUrl, isSessionStorageAvailable } from "../../../utils"
import { SearchPopup } from "./SearchPopup"
import { Button, Icon, scale, Image } from "@capioweb/ui-components/src"
import { LoginPopup } from "./LoginPopup"
import styled from "styled-components"

type DesktopHeaderProps = PrimaryMenuProps

const DesktopHeader: React.FC<DesktopHeaderProps> = (props) => {
	const {
		showSearchPopup,
		setShowSearchPopup,
		showLoginWindowPopup,
		setShowLoginWindowPopup,
	} = React.useContext(HeaderContext)
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const { alternateHeaderLayout } = React.useContext(UIContext)

	return (
		<Flex
			display={{
				_: "none",
				l: "flex",
				xl: props.hideLoginMenu ? "flex" : "none",
			}}
			w={1}
			maxw={INNER_MAX_WIDTH}
			style={{ margin: "0 auto" }}
			justifyContent="start"
			alignItems="center"
		>
			<Flex w={1} alignItems="center" columnGap={4}>
				<a href="/" aria-label="Tillbaka till startsidan">
					<Image
						height={24}
						src={assetBaseUrl() + props.mainLogo ?? headerLogoSvg}
						alt="Capio"
					/>
				</a>
				<DesktopPrimaryMenu menu={props.menu} />
			</Flex>

			{(!props.hideSearch || !props.hideLoginMenu) && (
				<Flex columnGap={1} w={32.5} justifyContent="end">
					{/* Search */}
					{!props.hideSearch && (
						<div style={{ position: "relative" }}>
							<Button
								onClick={() => {
									setShowSearchPopup(!showSearchPopup)
									setShowLoginWindowPopup(false)
								}}
								size="medium"
								variant="light-blue"
							>
								<Flex>
									<Icon
										mr={0.35}
										ml={-0.65}
										color="navy"
										icon="search"
										size={3}
									/>
								</Flex>

								{translate(translationKeys.search)}
							</Button>
							{showSearchPopup && (
								<SearchPopup
									label={translate(translationKeys.search)}
									showPopup={setShowSearchPopup}
								/>
							)}
						</div>
					)}
					{/* Login */}
					{!props.hideLoginMenu && (
						<div style={{ position: "relative" }}>
							<Button
								variant={alternateHeaderLayout ? "ghost-navy" : "navy"}
								onClick={() => {
									setShowLoginWindowPopup(!showLoginWindowPopup)
									setShowSearchPopup(false)
									if (isSessionStorageAvailable()) {
										sessionStorage.setItem("hideLoginPopup", "1")
									}
								}}
								size="medium"
							>
								{props.isLoggedIn && (
									<Flex>
										<Icon
											mr={1}
											color="white"
											icon="single-neutral"
											size={2.5}
										/>
									</Flex>
								)}
								{props.isLoggedIn
									? translate(translationKeys.menu)
									: translate(translationKeys.login)}
							</Button>
							{showLoginWindowPopup && (
								<LoginPopup
									loginMenuHeading={props.loginMenuHeading}
									loginMenuPreamble={props.loginMenuPreamble}
									loginItems={props.loginMenuItems}
								/>
							)}
						</div>
					)}
				</Flex>
			)}
		</Flex>
	)
}

export { DesktopHeader }
